<mat-card class="m-4">
  <mat-card-content>
    <div class="flex flex-justify flex-wrap">
      <span matListItemTitle class="w-full md:w-1/2">{{redemption.redemption.shippingMethod | shippingMethod}}</span>
      <span matListItemTitle class="w-full md:w-1/2">{{redemption.redemptionCode}}</span>
      <span matListItemTitle class="w-full md:w-1/2">{{redemption.redemption.orderID}}</span>
      <span class="w-full md:w-1/2">
        <div class="flex flex-justify flex-wrap">
          <div class="w-full md:w-1/2">{{redemption.redemption.address}}</div>
          <div class="w-full md:w-1/2">{{redemption.redemption.redeemedAt*1000 | date:'H:mm MM.d.y'}}</div>
        </div>
      </span>
    </div>
    @for (product of redemption.products; track product) {
      <mat-list role="list">
        <app-product-item [product]="product"></app-product-item>
      </mat-list>
    }
  </mat-card-content>
</mat-card>
